// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__3Rsp8","verticalPaddingLarge":"styles_verticalPaddingLarge__tm6OL"};